function injectScript(src, id) {
  const existing = document.getElementById(id);
  if (existing) return existing;

  const script = document.createElement('script');
  script.src = src;
  script.async = true;
  script.id = id;
  script.dataset.dollhouseAnalytics = 'true';
  document.head.appendChild(script);
  return script;
}

export function loadGa4(measurementId) {
  if (!measurementId || typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== 'function') {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }

  injectScript(`https://www.googletagmanager.com/gtag/js?id=${measurementId}`, 'dollhouse-ga4');
  window.gtag('js', new Date());
  window.gtag('config', measurementId, { send_page_view: false });
}

export function loadMetaPixel(pixelId) {
  if (!pixelId || typeof window === 'undefined') return;

  if (typeof window.fbq !== 'function') {
    const fbq = function fbq() {
      fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
    };
    fbq.queue = [];
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.push = fbq;
    window.fbq = fbq;
    window._fbq = fbq;
    injectScript('https://connect.facebook.net/en_US/fbevents.js', 'dollhouse-meta-pixel');
  }

  window.fbq('init', pixelId);
}
